import React, { useEffect, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css'; 
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import CancelIcon from '@mui/icons-material/Cancel';
import EditIcon from '@mui/icons-material/Edit';
import DeleteConfirm from '../../sharedComponents/DeleteConfirm';
import ConfirmDialog from '../../sharedComponents/ConfirmDialog';
import CircularProgress from '@mui/material/CircularProgress';
import Modal from 'react-modal';
import useManageOrder from './useManageOrder';
import { formatDate } from '../../utils/dateUtils';
import TextField from '@mui/material/TextField';
import { toast } from 'react-toastify';
import OrderDetail from '../customerProfile/OrderDetail';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import DatePicker from "react-datepicker";


const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    height: 'auto',
    width: '500px',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

const editCustomStyles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)',
    zIndex: 1000
  },
  content: {
    top: '5%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    width: '1100px',
    maxWidth: '95vw',
    maxHeight: '90vh',
    height: 'auto',
    transform: 'translateX(-50%)',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
};

const items = [
  {
    title: 'Confirm to Delete this Record ?',
    name: '',
    type: 'text',
  },
];

const Order = () => {
  const [rowData, setRowData] = useState([]);
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [isFormOpen, setIsFormOpen] = useState(false)
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [searchText, setSearchText] = useState('')
  const {orders, isLoading, getLatestOrder, deleteOrder, cancelOrder, totalOrderCount} = useManageOrder()
  const [order, setOrder] = useState({})
  const [cancelTarget, setCancelTarget] = useState(null)
  const [checked, setChecked] = useState(false)
  const [filterDateFrom, setFilterDateFrom] = useState('')
  const [filterDateTo, setFilterDateTo] = useState('')
  const [filterAmount, setFilterAmount] = useState('')
  const [dateRange, setDateRange] = useState([null, null])
  const [currentPage, setCurrentPage] = useState(1)
  const PAGE_SIZE = 50

  const IconComponent = (params) => {
    // Soft-deleted rows (superuser search) are read-only — no edit/delete/cancel
    if (params.data.deletedAt) {
      return <span className="text-xs font-semibold text-red-700">ลบแล้ว</span>
    }
    return <>
      <IconButton onClick={() => openEditForm(params.data)}>
        <EditIcon style={{ color: 'blue' }}/>
      </IconButton>
      <IconButton onClick={() => openConfirm(params.data.id)}>
        <DeleteIcon style={{ color: 'red' }}/>
      </IconButton>
      {!params.data.cancelStage && (
        <IconButton title="ยกเลิกออเดอร์" onClick={() => setCancelTarget(params.data)}>
          <CancelIcon style={{ color: '#ea580c' }}/>
        </IconButton>
      )}
    </>
  }

  const LinkRenderer = (params) => {
    return (
      <div>
        <a target="_blank" href={params.data.url}>{params.data.url}</a>
      </div>
    )
  }

  const ImageRenderer = (params) => {
    const isValidUrl = (url) => {
      try {
        const parsedUrl = new URL(url);
        return parsedUrl.hostname.length > 0 && parsedUrl.pathname.length > 1;
      } catch (_) {
        return false;
      }
    };
    return (
      <div>
        {params.data.imageUrl && isValidUrl(params.data.imageUrl) ? (
          <img src={params.data.imageUrl} alt="Thumbnail" style={{ maxHeight: '100px', maxWidth: '100%' }} />
        ) : (
          <CancelIcon style={{ color: 'red', fontSize: '40px' }} /> // Display the X icon
        )}
      </div>
    )
    };

  const columns = [
    { headerName: 'Contact', field: 'contact' ,flex : 1},
    { headerName: 'Smile Name', field: 'smileNameInput', flex : 1},
    { headerName: 'Order Date', field: 'orderDate' ,flex : 1},
    { headerName: 'Link', field: 'url' , cellRenderer: LinkRenderer},
    { headerName: 'Image', field: 'shipImageUrl', cellRenderer: ImageRenderer },
    { headerName: 'Amount', field: 'amount' ,flex : 1},
    { headerName: 'COD', field: 'isCod' ,flex : 1},
    { headerName: 'มัดจำ', field: 'isDown' ,flex : 1},
    { headerName: 'ค่าธรรมเนียม 7', field: 'sevenFee' ,flex : 1},
    {
      field: 'actions',
      cellRenderer: IconComponent,
    },
  ];

  const openConfirm = async (id) => {
    const recordToDelete = orders.find(w => w.id === id);
    if(recordToDelete) {
      setOrder(recordToDelete)
      setIsConfirmOpen(true)
    }
    setIsConfirmOpen(true)
  };

  const closeConfirm = () =>{
    setIsConfirmOpen(false)
  }

  const handleInputChange = (e) => {
    setSearchText(e.target.value)
  }

  const openEditForm = (order) => {
    setSelectedOrder(order);
    setIsFormOpen(true)
  }

  const closeForm = () =>{
    setSelectedOrder(null);
    setIsFormOpen(false)
  }

  const buildParams = (pageOverride) => ({
    searchText,
    checked,
    dateFrom: filterDateFrom,
    dateTo: filterDateTo,
    amount: filterAmount,
    page: pageOverride ?? currentPage,
    pageSize: PAGE_SIZE,
  })

  const fetchPage = async (pg) => {
    setCurrentPage(pg)
    await getLatestOrder(buildParams(pg))
  }

  const handleDeleteRecord = async () => {
    const response = await deleteOrder(order.uuid)
    if(response){
      toast.success("Delete Order successfully")
      closeConfirm()
    }else{
      toast.error("Something wrong.")
    }
    await fetchPage(currentPage)
  }

  // Mark an order cancelled → it enters the cancel tab (refund handled there).
  // Revertible there if it was a mistake.
  const handleCancelOrder = async () => {
    if (!cancelTarget) return;
    // allowVoid: this is a deliberate single cancel (confirm dialog) → a still-voidable
    // credit-card charge routes into the void lane, same as the customer-profile cancel.
    const ok = await cancelOrder({ orderId: cancelTarget.id, allowVoid: true });
    setCancelTarget(null);
    if (ok) { toast.success('ส่งเข้ารายการยกเลิกแล้ว'); await fetchPage(currentPage); }
    else toast.error('ยกเลิกไม่สำเร็จ');
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setCurrentPage(1)
    const response = await getLatestOrder(buildParams(1))
    if(!response){
      toast.error("มีบางอย่างผิดพลาด")
    }
  }  

  const handleSuccessUpdate = async () => {
    await fetchPage(currentPage)
  }

  useEffect(() => {
    getLatestOrder(buildParams(1))
  }, [])

  useEffect(() => {
    const formattedRecords = orders.map(record => ({
      ...record, // spread the other properties of the order
      orderDate: formatDate(record.orderDate), // overwrite orderDate with the formatted version
      contact : record.CustomerProfile.contact,
      /* option: record.ExpenseOption ? record.ExpenseOption.option : 'N/A',
      shipDate : record.ShipDate ? formatDate(record.ShipDate.shipDate) : "" */
    }));
    setRowData(formattedRecords)
  }, [orders])

  return (
    <div className="ag-theme-alpine" style={{ width: '100%' }}>
      <Modal
        isOpen={isFormOpen}
        onRequestClose={closeForm}
        style={editCustomStyles}
        ariaHideApp={false}
      >
        {selectedOrder && <OrderDetail order={selectedOrder} handleSuccessUpdate={handleSuccessUpdate}/>}
      </Modal>
      <Modal
        isOpen={isConfirmOpen}
        onRequestClose={closeConfirm}
        style={customStyles}
        ariaHideApp={false}
      >
        <DeleteConfirm
          items={items}
          data={orders}
          closeConfirm={closeConfirm}
          confirmFunction={handleDeleteRecord}
        />
      </Modal>
      <ConfirmDialog
        open={!!cancelTarget}
        title="ยืนยันการยกเลิกโดยผู้ขาย"
        message={cancelTarget ? `${cancelTarget.smileNameInput || ''}\n${cancelTarget.url || ''}\n\nรายการนี้ รายการจะเข้าสู่ขั้นตอนการยกเลิกและคืนเงิน ในหน้า รายการ -> ดำเนินการยกเลิก` : ''}
        confirmText="ยกเลิกออเดอร์"
        confirmColor="warning"
        onConfirm={handleCancelOrder}
        onClose={() => setCancelTarget(null)}
      />
      <div className='flex'>
        <h2>รายการสินค้า</h2>
        {isLoading && (
          <div className='ml-4 flex items-center'>
            <CircularProgress size={24} />
          </div>
        )}
        <div className='mb-2 ml-auto'>
          <FormControlLabel control={
            <Checkbox
              checked={checked}
              onChange={() => setChecked(!checked)}
            />} label="ดูรายการไม่มีรอบเรือ" 
          />
          
          <form onSubmit={handleFormSubmit} className='flex flex-wrap items-end gap-2'>
            <TextField
              sx={{ mr: 1 }}
              id="outlined-search"
              label="ค้นหา"
              type="search"
              onChange={handleInputChange}
              value={searchText}
            />
            <DatePicker
              selectsRange={true}
              startDate={dateRange[0]}
              endDate={dateRange[1]}
              onChange={(update) => {
                setDateRange(update)
                const [start, end] = update || []
                // Avoid timezone shift from toISOString(); format using local date parts.
                const toYmdLocal = (d) => {
                  if (!d) return ''
                  const y = d.getFullYear()
                  const m = String(d.getMonth() + 1).padStart(2, '0')
                  const day = String(d.getDate()).padStart(2, '0')
                  return `${y}-${m}-${day}`
                }
                setFilterDateFrom(toYmdLocal(start))
                setFilterDateTo(toYmdLocal(end))
              }}
              dateFormat="yyyy-MM-dd"
              customInput={
                <TextField
                  label="Date range"
                  InputLabelProps={{ shrink: true }}
                  size="small"
                  name="orderDateRange"
                  autoComplete="off"
                  sx={{ width: 280 }}
                  inputProps={{
                    autoComplete: 'off',
                    autoCorrect: 'off',
                    autoCapitalize: 'off',
                    spellCheck: 'false',
                  }}
                />
              }
            />
            <TextField
              label="Amount match"
              type="number"
              value={filterAmount}
              onChange={(e) => setFilterAmount(e.target.value)}
              size="small"
            />
            <IconButton type='submit' style={{ backgroundColor: 'green', borderRadius: '50%' }}>
              <SearchIcon fontSize="large" style={{ color: 'white' }}/>
            </IconButton>
            <IconButton
              type="button"
              onClick={() => {
                setFilterDateFrom('')
                setFilterDateTo('')
                setFilterAmount('')
                setDateRange([null, null])
              }}
              title="Clear filters"
            >
              <CancelIcon />
            </IconButton>
          </form>
        </div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 12, padding: '8px 0' }}>
        {totalOrderCount > 0 ? (
          <>
            <span style={{ fontSize: 14, color: '#555' }}>
              {((currentPage - 1) * PAGE_SIZE) + 1}–{Math.min(currentPage * PAGE_SIZE, totalOrderCount)} of {totalOrderCount}
            </span>
            <button
              style={{
                padding: '6px 16px',
                border: '1px solid #ccc',
                borderRadius: 4,
                background: currentPage <= 1 ? '#f0f0f0' : '#fff',
                cursor: currentPage <= 1 ? 'not-allowed' : 'pointer',
              }}
              disabled={currentPage <= 1}
              onClick={() => fetchPage(currentPage - 1)}
            >
              ← Prev
            </button>
            <span style={{ fontSize: 14 }}>
              Page {currentPage} / {Math.ceil(totalOrderCount / PAGE_SIZE)}
            </span>
            <button
              style={{
                padding: '6px 16px',
                border: '1px solid #ccc',
                borderRadius: 4,
                background: currentPage >= Math.ceil(totalOrderCount / PAGE_SIZE) ? '#f0f0f0' : '#fff',
                cursor: currentPage >= Math.ceil(totalOrderCount / PAGE_SIZE) ? 'not-allowed' : 'pointer',
              }}
              disabled={currentPage >= Math.ceil(totalOrderCount / PAGE_SIZE)}
              onClick={() => fetchPage(currentPage + 1)}
            >
              Next →
            </button>
          </>
        ) : (
          <span style={{ fontSize: 14, color: '#999' }}>No records found</span>
        )}
      </div>
      <AgGridReact
        rowData={rowData}
        columnDefs={columns}
        domLayout='autoHeight'
        enableCellTextSelection={true}
        defaultColDef={{ resizable: true }}
        // Soft-deleted orders (returned only for superuser searches) — highlight red
        getRowStyle={(params) => params.data.deletedAt ? { backgroundColor: '#fecaca' } : undefined}
        getRowHeight={(params) => {
          if (params.node.data.imageUrl) {
            return 100;
          }
          return 50;
        }}
      />
    </div>
  );
}

export default Order;
